import React from 'react';

import { cidadeNormal17 } from '../components/HeroBusiness/Data';

import HeaderMenu from '../components/HeaderMenu';
import HeroBusiness from '../components/HeroBusiness';
import Footer from '../components/Footer';


const CidadeNormal17 = () => {
  return (
    <>
    <HeaderMenu />
    <HeroBusiness {...cidadeNormal17}/>
    <Footer />
      
    </>
  )
}

export default CidadeNormal17
